import React, { Component } from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import './NewActivity.css';
import {isInputDateSupported, isFirefox} from '../../../Helpers.js';

import DashboardHeader from '../DashboardHeader/DashboardHeader.js';
import {AuthManager} from "../../../components/Authentication/AuthManager";
import {getRecentDisciplines} from "../../../api/profile/recentDisciplines.js";
import {addActivity} from "../../../api/internal/activities.js";
import {getLastReport} from "../../../api/internal/report.js";

import iconCalendar from 'static/img/icon-calendar-black.svg';
import iconDiscipline from 'static/img/icon-basketball.svg';
import iconDistance from 'static/img/icon-distance.svg';
import iconDuration from 'static/img/icon-duration.svg';
import iconCalories from 'static/img/icon-calories.svg';
import gifBravo from 'static/gif/bravo2.gif';
import gifBravoLeo from 'static/gif/bravo_leo.gif';
import gifBravoDeNiro from 'static/gif/bravo_de-niro.gif';
import gifDontKnow from 'static/gif/dont-know.gif';

class NewActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      type: 0,
      category: '',
      favoriteCategories: [],
      distanceInKiloMeteres: '',
      movingTimeInHours: '',
      movingTimeInMinutes: '',
      addingActivityStatus: 'normal',
      showCalories: false,
      calories: '',
      congratsGif: gifBravo,
      lastReportMonth: 0,
      lastReportYear: 0
    };
    this._authManager = new AuthManager();
  }

  resetForm = () => {
    this.setState({
      startDate: new Date(),
      type: 0,
      category: '',
      favoriteCategories: [],
      distanceInKiloMeteres: '',
      movingTimeInHours: '',
      movingTimeInMinutes: '',
      addingActivityStatus: 'normal',
      showCalories: false,
      calories: ''
    });
    this.getLastThreeActivities();
  }

  setCategoryAndType = (e) => {
    this.setState({
      category: e.target.getAttribute('data-category'),
      type: Number(e.target.getAttribute('data-type'))
    });
  }
  selectCategoryAndType = (e) => {
    const select = e.target;
    const option = select.options[select.selectedIndex]
    this.setState({
      category: select.value,
      type: Number(option.dataset.type)
    });
  }
  toggleShowCalories = () => {
    this.setState(prevState => ({
      showCalories: !prevState.showCalories,
      calories: ''
    }));
  }

  addNewActivity = () => {
    let timeInMinutes = (this.state.movingTimeInHours) * 60 + (this.state.movingTimeInMinutes)*1;
    let distanceInMeters = parseFloat(this.state.distanceInKiloMeteres, 10)*1000;

    let newEntry = {
      "startDate": this.state.startDate, // "yyyy-mm-dd",
      "type": this.state.category,
      "distanceInMeters": distanceInMeters,
      "movingTimeInMinutes": timeInMinutes,
      "calories": parseInt(this.state.calories, 10)
    };

    console.log("adding new ENTRY: ", newEntry);

    if(this.validate() ){
      addActivity(this.props.user.profile.sub, newEntry)
        .then(
          (result) => {
            console.log('RESULT:', result);
            if(result.status === 200) {
              this.setState({addingActivityStatus: 'success'});
              this.props.onActivityAdded();
              this.setGif();
            } else {
              console.error('You probably entered wrong values to your entry');
              this.setState({addingActivityStatus: 'fail'});
            }
          },
          (error) => { console.error('Something went wrong with adding new activity', error); this.setState({addingActivityStatus: 'fail'})}
      );
    }
  };

  validate = () => {
    let timeInMinutes = (this.state.movingTimeInHours) * 60 + (this.state.movingTimeInMinutes)*1;
    let distanceInMeters = parseInt(this.state.distanceInKiloMeteres, 10)*1000;
    let isValid = true;

    var elements = document.getElementsByClassName('error');
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
    let activityDate = new Date(this.state.startDate);
    //activityDate.setHours(0,0,0,0);
    const activityMonth = activityDate.getMonth()+1;
    const activityYear = activityDate.getFullYear();

    let todayDate = new Date();

    if(this.state.startDate === ''){
      this.showError('Please type the correct date', 'activityDateDiv');
      isValid = false;
    } else {
      //block activities from the future
      if(activityDate > todayDate){
        this.showError('You cannot add activities in the future', 'activityDateDiv');
        isValid = false;
      } else if(this.isActivityBeforeLastReport(activityYear, activityMonth) ){
        this.showError('Pick a day in the current month', 'activityDateDiv');
        isValid = false;
      }
    }

    if(this.state.category === ''){
      this.showError('Please select one category', 'activityCategoryDiv');
      isValid = false;
    }
    if(this.state.type === 1 && (isNaN(timeInMinutes) || timeInMinutes <= 0) ){
      this.showError('Please type the correct time', 'activityDurationDiv');
      isValid = false;
    }
    if(this.state.type === 1 && this.state.movingTimeInHours > 24){
      this.showError('You cannot type more than 24 hours in 1 entry', 'activityDurationDiv');
      isValid = false;
    }
    if(this.state.type === 1 && this.state.movingTimeInMinutes > 90){
      this.showError('You cannot type more than 90min in one entry', 'activityDurationDiv');
      isValid = false;
    }
    if(this.state.type === 2 && (isNaN(distanceInMeters) || distanceInMeters < 1000) ){
      this.showError('Please enter the correct distance', 'activityDistanceDiv');
      isValid = false;
    }
    if(this.state.type === 2 && distanceInMeters > 500000 ){
      this.showError('Distance cannot be more than 500km', 'activityDistanceDiv');
      isValid = false;
    }
    if(this.state.showCalories && this.state.calories <= 0 ){
      this.showError('Please enter the correct amount of burned calories','activityCaloriesDiv');
      isValid = false;
    }
    if(this.state.showCalories && this.state.calories > 10000 ){
      this.showError('You cannot add more than 10 000 kcal per 1 activity','activityCaloriesDiv');
      isValid = false;
    }
    return isValid;
  }

  showError = (errorMsg, where) => {
    console.log('----errorMsg', errorMsg);
    var errorDiv = document.createElement('div');
    errorDiv.className = 'error';
    errorDiv.innerHTML = errorMsg;
    document.getElementById(where).appendChild(errorDiv);
  }

  getLastThreeActivities = () => {
    getRecentDisciplines()
      .then(
        (result) => {
          this.setState({favoriteCategories: result });
          },
        (error) => {
          this.setState({favoriteCategories: []});
          console.error('Error:', error);
        }
      );
  }
  getLastReportDate = () =>{
    getLastReport()
      .then(
        (result) => {
          this.setState({
            lastReportMonth: result.month,
            lastReportYear: result.year
          })
        },
        (error) => {
          console.log('getLastReportDate() - ERROR', error);
        }
      )
  }
  isActivityBeforeLastReport(activityYear, activityMonth){
    const lastReportDate = new Date(this.state.lastReportYear, this.state.lastReportMonth - 1);
    const activityDate = new Date(activityYear, activityMonth - 1);
    if(lastReportDate >= activityDate){
        return true;
    } else {
        return false;
    }
  }
  setGif = () =>{
    let gifSrc;
    const randomNumber = Math.ceil(Math.random() *3 );
    switch(randomNumber){
      case 1:
        gifSrc = gifBravo;
        break;
      case 2:
        gifSrc = gifBravoLeo;
        break;
      case 3:
        gifSrc = gifBravoDeNiro;
        break;
      default:
        gifSrc = gifBravo;
        break;
    }
    this.setState({congratsGif: gifSrc})
  }

  render() {
    let threeFavoriteCategories = [];
    if(this.props.categories.length > 0 && this.state.favoriteCategories.length > 0){
      threeFavoriteCategories = this.state.favoriteCategories.map( cat =>  this.props.categories.filter(i => i.name === cat)[0]);
    }

    return (
      <React.Fragment>
        <DashboardHeader
          header="Add activity"
          user={this.props.user}
        />
        <div className="Dashboard-content NewActivity">
          <div className={`NewActivity__form ${this.state.addingActivityStatus === 'normal' ? '' : 'hide'}`}>

            <div className="NewActivity__form-row" id="activityDateDiv">
              <label htmlFor="activityDate" className="NewActivity__form-label">
                <img src={iconCalendar} className="NewActivity__form-labelIcon" alt="date"/>Date
              </label>
              {(isInputDateSupported() && !isFirefox() ?
                <React.Fragment>
                  <input id="activityDate" type="date" required
                    value={this.state.startDate.toISOString().substr(0, 10)}
                    onChange={(e) => {
                      const today = new Date();
                      const date = e.target.value.split("-");
                      this.setState({startDate: new Date(date[0], parseInt(date[1],10) - 1, date[2], today.getHours(), today.getMinutes(), today.getSeconds() )})

                    }}
                    className="NewActivity__form-inputDate"
                  />
                  <div className="NewActivity__form-inputDate-calendar"></div>
                </React.Fragment>
                :
                <DatePicker
                  selected={this.state.startDate}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => {this.setState({startDate: date})} }
                />
              )}
            </div>

            <div className="NewActivity__form-row" id="activityCategoryDiv">
              <label htmlFor="activityCategory" className="NewActivity__form-label">
                <img src={iconDiscipline} className="NewActivity__form-labelIcon" alt="discipline"/>Discipline
              </label>
              <div className="NewActivity__tiles" >
                {threeFavoriteCategories.length > 0 && threeFavoriteCategories.slice(0,3).map( (i) =>
                  <div key={i.name} data-category={i.name} data-type={i.type} onClick={(e) => this.setCategoryAndType(e)} className={`NewActivity__tilesItem ${this.state.category === i.name ? 'active' : ''}`}>
                    <img src={i.icon} alt={i.name} className="NewActivity__tilesItem-iconComponent" />
                    <h6 className="NewActivity__tilesItem-category">{i.displayName}</h6>
                  </div>
                )}
              </div>
              <div className="NewActivity__select">
                <select id="activityCategory" value={this.state.category} onChange={(e) => this.selectCategoryAndType(e)} >
                  <option value="" data-type="0" >Show all</option>
                  {this.props.categories && this.props.categories.map( (i) =>
                    <option key={i.name} value={i.name} data-type={i.type} >
                      {i.displayName}
                    </option>
                  )}
                </select>
              </div>
            </div>

            {this.state.type === 1 && (
            <div className="NewActivity__form-row" id="activityDurationDiv">
              <label htmlFor="activityDurationHours" className="NewActivity__form-label">
                <img src={iconDuration} alt="duration" className="NewActivity__form-labelIcon" />Duration
              </label>
              <div className="NewActivity__form-input Duration">
                <input id="activityDurationHours" type="number" min="0" max="24" className="NewActivity__form-inputHours" placeholder="00" step="1"
                  value={this.state.movingTimeInHours}
                  onChange={(e) => {
                      this.setState({movingTimeInHours: e.target.value })
                  }}
                />
                <div className="NewActivity__form-inputUnit">hr</div>
              </div>
              <div className="NewActivity__form-input Duration">
                <input id="activityDurationMinutes" type="number" min="0" max="59" className="NewActivity__form-inputMinutes" placeholder="00" step="10"
                  value={this.state.movingTimeInMinutes}
                  onChange={(e) => this.setState({movingTimeInMinutes: e.target.value })}
                />
                <div className="NewActivity__form-inputUnit">min</div>
              </div>
            </div>
            )}

            {this.state.type === 2 && (
            <div className="NewActivity__form-row" id="activityDistanceDiv">
              <label htmlFor="activityDistance" className="NewActivity__form-label">
                <img src={iconDistance} alt="distance" className="NewActivity__form-labelIcon" />Distance
              </label>
              <div className="NewActivity__form-input Distance">
                <input id="activityDistance" type="number" min="0" max="300" className="NewActivity__form-inputKilometeres" placeholder="0" value={this.state.distanceInKiloMeteres} onChange={(e) => this.setState({distanceInKiloMeteres: e.target.value })} />
                <div className="NewActivity__form-inputUnit">kilometres</div>
              </div>
            </div>
            )}

            <div className="NewActivity__form-row" >
                <input id="activitySwitch" type="checkbox" className="NewActivity__form-switch" checked={this.state.showCalories} onChange={() => this.toggleShowCalories()}/>
                <label htmlFor="activitySwitch" className="NewActivity__form-switchLabel">I want to add calories manually</label>
            </div>

            {this.state.showCalories && (
            <div className="NewActivity__form-row" id="activityCaloriesDiv">
              <label htmlFor="activityCalories" className="NewActivity__form-label">
                <img src={iconCalories} alt="calories" className="NewActivity__form-labelIcon" />Calories
              </label>
              <div className="NewActivity__form-input Calories">
                <input id="activityCalories" type="number" min="0" max="10000" className="NewActivity__form-inputCalories" placeholder="0" value={this.state.calories} onChange={(e) => this.setState({calories: e.target.value })} />
                <div className="NewActivity__form-inputUnit">kcal</div>
              </div>
            </div>
            )}

            <div className="NewActivity__form-row border">
              <input type="button" value="Save" className="Button NewActivity__form-save" onClick={this.addNewActivity}/>
            </div>
          </div>

          <div className={`NewActivity__saved ${this.state.addingActivityStatus === 'success' ? '' : 'hide'}`}>
            <h3 className="NewActivity__saved-header">Great job!</h3>
            <p className="NewActivity__saved-text">Your activity has been saved.</p>
            <img className="NewActivity__saved-gif" src={this.state.congratsGif} alt="bravo" />
            <button className="Button NewActivity__saved-button" onClick={e => this.resetForm()}>Add another</button>
          </div>

          <div className={`NewActivity__saved ${this.state.addingActivityStatus === 'fail' ? '' : 'hide'}`}>
            <h3 className="NewActivity__saved-header">Something went wrong!</h3>
            <p className="NewActivity__saved-text">Your activity hasn&apos;t been saved.</p>
            <img className="NewActivity__saved-gif" src={gifDontKnow} alt="bravo" />
            <button className="Button NewActivity__saved-button" onClick={e => this.setState({addingActivityStatus: 'normal'})}>Try again</button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  componentDidMount(){
    this.getLastThreeActivities();
    this.getLastReportDate();
  }

}
export default NewActivity;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/NewActivity/NewActivity.js